import { formatShort } from '@/lib/money'
import { useSession } from '@/hooks/use-session'
import { useToast } from '@/components/generals/toaster'
import { MAX_BET, MIN_BET } from '@/constants/site'

// Checks shared by every game before a bet goes to the server.
export function usePlay() {
    const { user, maintenance, ensurePlayer, openModal } = useSession()
    const toast = useToast()

    const canBet = (amount: number | null): amount is number => {
        if (!ensurePlayer()) return false

        if (maintenance) {
            toast('Games are paused for maintenance. Your balance is safe.', 'info')

            return false
        }

        if (user?.suspended) {
            toast('Your account is suspended. Contact staff on DonutSMP.', 'error')

            return false
        }

        if (amount === null) {
            toast(`Enter a bet between ${formatShort(MIN_BET)} and ${formatShort(MAX_BET)}.`, 'error')

            return false
        }

        if ((user?.balance ?? 0) < amount) {
            toast('Not enough balance. Deposit in your wallet to keep playing.', 'error')
            openModal({ name: 'wallet', tab: 'deposit' })

            return false
        }

        return true
    }

    return { canBet, toast }
}
